import { graphql } from 'gatsby';
import { exists, getKey, isValidArray } from '../../../helpers';

/**
 * Promotions widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the widget
 * @returns {Object} widget definition
 */
export const promotion = function promotion(props, locale) {
  const items = getKey(props, 'items');
  const innerLink = getKey(props, 'innerLink');

  return {
    items:
      isValidArray(items)
      && items.map((item) => {
        const descriptionColor = getKey(item, 'descriptionColor');
        const titleColor = getKey(item, 'titleColor');
        const termsColor = getKey(item, 'termsColor');
        const link = innerLink ? `${locale}/${getKey(item, 'link')}` : getKey(item, 'link');

        return {
          key: getKey(item, 'key'),
          title: getKey(item, `title_${locale}`),
          description: getKey(item, `description_${locale}`),
          callToAction: getKey(item, `callToAction_${locale}`),
          descriptionColor: exists(descriptionColor) ? descriptionColor : undefined,
          titleColor: exists(titleColor) ? titleColor : undefined,
          termsColor: exists(termsColor) ? termsColor : undefined,
          terms: getKey(item, `terms_${locale}`),
          link,
          innerLink: getKey(item, 'innerLink'),
          backgroundImage: getKey(item, 'backgroundImage.url')
        };
      })
  };
}

export default function promotionprovider(props, locale) {
  console.log(props);
  const key = getKey(props, 'key');

  return {
    locale,
    promotionId: key
  };
}


/**
 * GraphQL query
 */
export const query = graphql`
  fragment Promotions on StrapiWidgetrels {
    promotion {
      key: id
      items: promotionitems {
        key: id
        title_en
        title_es
        titleColor
        description_en
        description_es
        callToAction_en
        callToAction_es
        descriptionColor
        terms_en
        terms_es
        termsColor
        link
        innerLink
        backgroundImage {
          childImageSharp {
            fluid(maxWidth: 960, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      widgetPosition
    }
  }
`;
